<template>
  <div :class="['pricing-card', plan.isHighlighted && showHighlighted ? '-is-highlighted' : '', showHighlighted ? '-show-highlighted': '', `-${size}`]">
    <div
      v-if="plan.isHighlighted && showHighlighted"
      class="_highlight"
    >
      Most popular
    </div>
    <div class="_content">
      <div class="_top">
        <div class="_icon">
          <img :src="plan.icon.src">
        </div>
        <div class="_title">
          {{ plan.title }}
        </div>
        <div class="_sub-title">
          {{ plan.subTitle }}
        </div>
      </div>
      <div class="_bottom">
        <div class="_price">
          {{ plan.price }}
        </div>
        <div class="_terms">
          <div
            v-for="(term, i) in plan.terms"
            :key="i"
            class="_term"
          >
            {{ term }}
          </div>
        </div>
        <div class="_cta">
          <c-button
            class="_cta-button"
            :color="plan.cta.isHighlighted ? 'primary' : 'default'"
            :outlined="!(plan.isHighlighted && showHighlighted)"
            stretch
            :disabled="plan.cta.disabled"
            @click="$emit('cta-click', plan)"
          >
            {{ plan.cta.text }}
          </c-button>
        </div>
        <div class="_benefits">
          <div
            v-for="(item, index) in plan.benefits"
            :key="index"
            class="_benefit"
          >
            <div class="_icon">
              <c-icon type="check" />
            </div>
            <div class="_text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CButton from 'shared/components/CButton.vue';
import CIcon from 'shared/components/CIcon.vue';

export default {
  name: 'PricingCard',
  props: {
    plan: {
      type: Object,
      required: true,
    },
    showHighlighted: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'normal',
    },
  },
  emits: ['cta-click'],
  components: { CButton, CIcon },
};
</script>
<style
  scoped
  type="text/scss"
  lang="scss"
>
@import "shared/assets/scss/box-shadow";

.pricing-card {
  border-radius: 10px;

  ._highlight {
    background-color: map_get($red, 'lighten-5');
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 1rem 2rem;
    color: map_get($red, 'darken-3');
    font-weight: bold;
    border: 1px solid map_get($grey, 'lighten-3');
  }

  ._content {
    ._top {
      background-color: white;
      border: 1px solid map_get($grey, 'lighten-3');
      padding: 2rem;

      ._icon {
        height: 80px;
        width: auto;
      }

      ._title {
        font-size: 30px;
        font-weight: bold;
      }

      ._sub-title {
        font-size: 18px;
        height: 81px;
      }
    }

    ._bottom {
      background-color: map_get($grey, 'lighten-6');
      padding: 2rem;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      border: 1px solid map_get($grey, 'lighten-3');

      ._price {
        font-size: 40px;
        font-weight: bold;
      }

      ._cta {
        background-color: white;
      }

      ._terms {
        margin-bottom: 1rem;

        ._term {
          height: 2.4rem;
          color: map_get($grey, 'base');
        }
      }

      ._benefits {
        margin-top: 3rem;

        ._benefit {
          display: flex;
          align-items: center;
          margin-bottom: 1.2rem;
          font-weight: 500;

          ._icon {
            margin-right: 1.6rem;
          }
        }
      }
    }
  }

  &.-small {
    ._content {
      ._top {
        ._title {
          font-size: 24px;
        }

        ._sub-title {
          font-size: 16px;
          height: 70px;
        }
      }

      ._bottom {
        ._price {
          font-size: 32px;
        }
      }
    }
  }

  &:not(.-is-highlighted) {
    &.-show-highlighted {
      margin-top: 4.3rem;
    }

    ._content {
      ._top {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
    }
  }

  &.-is-highlighted {
    ._cta-button {
      @include box_shadow(1);
    }
  }
}
</style>
